export default "__VITE_ASSET__Mn8yIrP5__"